import React from "react";
import {
  Box,
  CircularProgress,
  List,
  Popover,
  Typography,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import NotificationsOffOutlinedIcon from "@mui/icons-material/NotificationsOffOutlined";

import NotificationItem from "./NotificationItem";
import NotificationState from "./NotificationState";

function NotificationPanel({
  anchorEl,
  isError,
  isLoading,
  items,
  onClose,
  onNotificationClick,
  open,
  refetch,
  unreadCount,
  isNotificationUnread,
}) {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      className="notification-popover"
    >
      <Box>
        <Box className="notification-header">
          <Typography className="notification-title">Notifications</Typography>
        </Box>

        {isLoading ? (
          <NotificationState
            icon={<CircularProgress size={28} />}
            title="Loading notifications"
            description="Fetching the latest updates for you."
          />
        ) : null}

        {!isLoading && isError ? (
          <NotificationState
            icon={<InfoOutlinedIcon className="notification-state-icon" />}
            title="Unable to load notifications"
            description="Please try again in a moment."
            action={
              <Typography
                component="button"
                onClick={() => refetch()}
                sx={{
                  border: 0,
                  background: "transparent",
                  color: "#1d4f80",
                  fontWeight: 700,
                  cursor: "pointer",
                  mt: 1,
                }}
              >
                Retry
              </Typography>
            }
          />
        ) : null}

        {!isLoading && !isError && items.length === 0 ? (
          <NotificationState
            icon={<NotificationsOffOutlinedIcon className="notification-state-icon" />}
            title="No notifications yet"
            description="New mentions and assignments will appear here."
          />
        ) : null}

        {!isLoading && !isError && items.length > 0 ? (
          <List className="notification-list">
            {items.map((notification) => (
              <NotificationItem
                key={notification.notification_id}
                notification={notification}
                isUnread={isNotificationUnread(notification)}
                onClick={onNotificationClick}
              />
            ))}
          </List>
        ) : null}
      </Box>
    </Popover>
  );
}

export default React.memo(NotificationPanel);
